import React from 'react';
import GreenCardOrder from '../../GreenCardOrder';
import DownloadApp from '../views/downloadApp.c';
import Breadcrumbs from "../../../auxiliary-components/Breadcrumbs"
import { MAIN, CARDS, PLATINUM_CARD } from '../../../auxiliary-components/Breadcrumbs/collection/breadcrumbs.config';
import CustomDropdown from '../../../auxiliary-components/shared/CustomDropdown';
import green_cad_img from '../img/green_card_img.png';
import platinum_cad_img from '../img/patinum_card_img.png';
import yellow_card_img from '../img/yellow_card_img.png';
import support_card_img from '../img/support_card_img.png';
import ukrainian_card_img from '../img/ukrainian_card_img.png';
import atb_card_img from '../img/atb_card_img.png';
import profit_card_img from '../img/profit_card_list_img.png';
import repair_card_img from '../img/repair_card_img.png';
import kid_card_img from '../img/kid_card_img.png';
import bolt_card_img from '../img/bolt_card_img.png';
import diia_card_img from '../img/diia_card_img.png';
import cashback_ua from '../img/cashback_ua_img_2.png';
import CardListItem from "./components/CardListItem";
import '../less/list.less';

export default function template() {
    const isMobile = this.isViewportMobile(),
      modal = this.state.showModal ? <GreenCardOrder closeModal={this.toggleModal} isMobile={isMobile} card={this.state.cardType}/> : '',
        links = [MAIN, CARDS],
        activeCardsData = [
          {
            name: 'CARDS_GC_TITLE',
            type: 'active',
            img: green_cad_img,
            info: [{ title: 'CARDS_GC_INFO_TITLE_1', desc: 'CARDS_GC_INFO_DESC_1'},
                { title: 'CARDS_GC_INFO_TITLE_2', desc: 'CARDS_GC_INFO_DESC_2' },
                { title: 'CARDS_GC_INFO_TITLE_3', desc: 'CARDS_GC_INFO_DESC_3' }],
            btns: [{ text: "FIND_OUT_MORE", class: 'btn-transparent', href: '/cards/green' }, { text: "GC_BTN_ORDER", class: 'btn-success', id:'btn-order-green', toggleModal: () => this.toggleModal('green')}],
        },
        {
            name: 'CARDS_PLATINUM_TITLE',
            type: 'active',
            img: platinum_cad_img,
            info: [{ title: 'CARDS_PLATINUM_DESC_1_TITLE', desc: 'CARDS_PLATINUM_DESC_1_TEXT'},
                { title: 'CARDS_PLATINUM_DESC_2_TITLE', desc: 'CARDS_PLATINUM_DESC_2_TEXT' },
                { title: 'CARDS_PLATINUM_DESC_3_TITLE', desc: 'CARDS_PLATINUM_DESC_3_TEXT' }],
            btns: [{ text: "FIND_OUT_MORE", class: 'btn-transparent', href: PLATINUM_CARD.link }, { text: "GC_BTN_ORDER", class: 'btn-success', id:'btn-order-platinum', toggleModal: () => this.toggleModal('platinum')}],
        },
        {
            name: 'YELLOW_CARD_TITLE',
            type: 'active',
            img: yellow_card_img,
            info: [{ title: 'CARDS_YELLOW_INFO_TITLE_1', desc: 'CARDS_YELLOW_INFO_DESC_1'},
                { title: 'CARDS_YELLOW_INFO_TITLE_2', desc: 'CARDS_YELLOW_INFO_DESC_2' },
                { title: 'CARDS_YELLOW_INFO_TITLE_3', desc: 'CARDS_YELLOW_INFO_DESC_3' }],
            btns: [{ text: "FIND_OUT_MORE", class: 'btn-transparent', href: '/cards/yellow' }, { text: "GC_BTN_ORDER", class: 'btn-success', id:'btn-order-yellow', toggleModal: () => this.toggleModal('yellow')}],
        }],
        otherCardsData = [
            {
                name: 'ATB_LIST_TITLE',
                type: 'other',
                img: atb_card_img,
                info: [{ title: 'ATB_LIST_DESC_1_TITLE', desc: 'ATB_LIST_DESC_1_TEXT'},
                    { title: 'ATB_LIST_DESC_2_TITLE', desc: 'ATB_LIST_DESC_2_TEXT' },
                    { title: 'ATB_LIST_DESC_3_TITLE', desc: 'ATB_LIST_DESC_3_TEXT' }],
                btns: [{ text: "FIND_OUT_MORE", class: 'btn-transparent', href: '/cards/atb' }, { text: "GC_BTN_ORDER", class: 'btn-success', id:'btn-order-atb', toggleModal: () => this.toggleModal('atb') }],
            },
            {
                name: 'PROFIT_CARD_LIST_TITLE',
                type: 'other',
                img: profit_card_img,
                info: [{ title: 'PROFIT_CARD_LIST_DESC_1_TITLE', desc: 'PROFIT_CARD_LIST_DESC_1_TEXT'},
                    { title: 'PROFIT_CARD_LIST_DESC_2_TITLE', desc: 'PROFIT_CARD_LIST_DESC_2_TEXT' },
                    { title: 'PROFIT_CARD_LIST_DESC_3_TITLE', desc: 'PROFIT_CARD_LIST_DESC_3_TEXT' }],
                btns: [{ text: "FIND_OUT_MORE", class: 'btn-transparent', href: '/cards/vygoda' }, { text: "GC_BTN_ORDER", class: 'btn-success', id:'btn-order-profit', toggleModal: () => this.toggleModal('vygoda')}],
            },
            {
                name: 'BOLT_CARD_LIST_TITLE',
                type: 'other',
                img: bolt_card_img,
                info: [{ title: 'BOLT_CARD_LIST_DESC_1_TITLE', desc: 'BOLT_CARD_LIST_DESC_1_TEXT'},
                    { title: 'BOLT_CARD_LIST_DESC_2_TITLE', desc: 'BOLT_CARD_LIST_DESC_2_TEXT' },
                    { title: 'BOLT_CARD_LIST_DESC_3_TITLE', desc: 'BOLT_CARD_LIST_DESC_3_TEXT' }],
                btns: [{ text: "FIND_OUT_MORE", class: 'btn-transparent', href: '/cards/bolt' }, { text: "GC_BTN_ORDER", class: 'btn-success', id:'btn-order-bolt', toggleModal: () => this.toggleModal('bolt')}],
            },
            {
                name: 'KID_CARD_LIST_TITLE',
                type: 'other',
                img: kid_card_img,
                info: [{ title: 'KID_CARD_LIST_DESC_1_TITLE', desc: 'KID_CARD_LIST_DESC_1_TEXT'},
                    { title: 'KID_CARD_LIST_DESC_2_TITLE', desc: 'KID_CARD_LIST_DESC_2_TEXT' },
                    { title: 'KID_CARD_LIST_DESC_3_TITLE', desc: 'KID_CARD_LIST_DESC_3_TEXT' }],
                btns: [{ text: "FIND_OUT_MORE", class: 'btn-transparent', href: '/cards/kid-card' }, { text: "GC_BTN_ORDER", class: 'btn-success', id:'btn-order-kid-card', toggleModal: () => this.toggleModal('kid-card')}],
            },
            {
                name: 'REPAIR_CARD_LIST_TITLE',
                type: 'other',
                img: repair_card_img,
                info: [{ title: 'REPAIR_CARD_LIST_DESC_1_TITLE', desc: 'REPAIR_CARD_LIST_DESC_1_TEXT'},
                    { title: 'REPAIR_CARD_LIST_DESC_2_TITLE', desc: 'REPAIR_CARD_LIST_DESC_2_TEXT' },
                    { title: 'REPAIR_CARD_LIST_DESC_3_TITLE', desc: 'REPAIR_CARD_LIST_DESC_3_TEXT' }],
                btns: [{ text: "FIND_OUT_MORE", class: 'btn-transparent', href: '/cards/eVidnovlennia' }, { text: "GC_BTN_ORDER", class: 'btn-success', id:'btn-order-repair', toggleModal: () => this.toggleModal('eVidnovlennia')}],
            },
            {
                name: 'UKRANIANS_TOGETHER_TITLE',
                type: 'other',
                img: ukrainian_card_img,
                info: [{ title: 'CARDS_GC_INFO_TITLE_3', desc: 'CARDS_GC_INFO_DESC_3'},
                    { title: 'CARDS_GC_INFO_TITLE_2', desc: 'CARDS_GC_INFO_DESC_2' },
                    { title: 'CARDS_GC_INFO_TITLE_1', desc: 'CARDS_GC_INFO_DESC_1' }],
                btns: [{ text: "FIND_OUT_MORE", class: 'btn-transparent', href: '/cards/ukrainians_together' }, { text: "GC_BTN_ORDER", class: 'btn-success', id:'btn-order-ukrainians_together', toggleModal: () => this.toggleModal('ukrainians_together') }],
            },
            {
                name: 'PROJECT_SUPPORT_LIST_TITLE',
                type: 'other',
                img: support_card_img,
                info: [{ title: 'PROJECT_SUPPORT_LIST_DESC_1_TITLE', desc: 'PROJECT_SUPPORT_LIST_DESC_1_TEXT'},
                    { title: 'PROJECT_SUPPORT_LIST_DESC_2_TITLE', desc: 'PROJECT_SUPPORT_LIST_DESC_2_TEXT' },
                    { title: 'PROJECT_SUPPORT_LIST_DESC_3_TITLE', desc: 'PROJECT_SUPPORT_LIST_DESC_3_TEXT' }],
                btns: [{ text: "FIND_OUT_MORE", class: 'btn-transparent', href: '/cards/project-support' }, { text: "GC_BTN_ORDER", class: 'btn-success', id:'btn-order-project-support', toggleModal: () => this.toggleModal('support')}],
            },
            {
                name: 'CASHBACK_UA_LIST_TITLE',
                type: 'other',
                img: cashback_ua,
                info: [{ title: 'CASHBACK_UA_LIST_DESC_1_TITLE', desc: 'CASHBACK_UA_LIST_DESC_1_TEXT'},
                    { title: 'CASHBACK_UA_LIST_DESC_2_TITLE', desc: 'CASHBACK_UA_LIST_DESC_2_TEXT' },
                    { title: 'CASHBACK_UA_LIST_DESC_3_TITLE', desc: 'CASHBACK_UA_LIST_DESC_3_TEXT' }],
                btns: [{ text: "FIND_OUT_MORE", class: 'btn-transparent', href: '/cards/cashback_ua' }, { text: "GC_BTN_ORDER", class: 'btn-success', id:'btn-order-cashback_ua', toggleModal: () => this.toggleModal('cashback_ua')}],
            },
            {
                name: 'DIIA_CARD_LIST_TITLE',
                type: 'other',
                img: diia_card_img,
                info: [{ title: 'CASHBACK_UA_LIST_DESC_1_TITLE', desc: 'CASHBACK_UA_LIST_DESC_1_TEXT'},
                    { title: 'CASHBACK_UA_LIST_DESC_2_TITLE', desc: 'CASHBACK_UA_LIST_DESC_2_TEXT' },
                    { title: 'CASHBACK_UA_LIST_DESC_3_TITLE', desc: 'CASHBACK_UA_LIST_DESC_3_TEXT' }],
                btns: [{ text: "FIND_OUT_MORE", class: 'btn-transparent', href: '/cards/diia' }, { text: "GC_BTN_ORDER", class: 'btn-success', id:'btn-order-diia-card', toggleModal: () => this.toggleModal('diia')}],
            },
        ],
        archiveCardsData = [
            {
                name: 'CARDS_GOLD_TITLE',
                type: 'archive',
                info: [{ title: 'CARDS_GOLD_INFO_TITLE_1', desc: 'CARDS_GOLD_INFO_DESC_1'},
                    { title: 'CARDS_GOLD_INFO_TITLE_2', desc: 'CARDS_GOLD_INFO_DESC_2' },
                    { title: 'CARDS_GOLD_INFO_TITLE_3', desc: 'CARDS_GOLD_INFO_DESC_3' }],
                btns: [{ text: "FIND_OUT_MORE", class: 'btn-success', href: '/cards/gold' }],
            },
            {
                name: 'CARDS_UNIVERSAL_TITLE',
                type: 'archive',
                info: [{ title: 'CARDS_UNIVERSAL_INFO_TITLE_1', desc: 'CARDS_UNIVERSAL_INFO_DESC_1'},
                    { title: 'CARDS_UNIVERSAL_INFO_TITLE_2', desc: 'CARDS_UNIVERSAL_INFO_DESC_2' },
                    { title: 'CARDS_UNIVERSAL_INFO_TITLE_3', desc: 'CARDS_UNIVERSAL_INFO_DESC_3' }],
                btns: [{ text: "FIND_OUT_MORE", class: 'btn-success', href: '/cards/kun'}],
            },
            {
                name: 'CARDS_KDV_TITLE',
                type: 'archive',
                info: [{ title: 'CARDS_KDV_INFO_TITLE_1', desc: 'CARDS_KDV_INFO_DESC_1'},
                    { title: 'CARDS_KDV_INFO_TITLE_2', desc: 'CARDS_KDV_INFO_DESC_2' },
                    { title: 'CARDS_KDV_INFO_TITLE_3', desc: 'CARDS_KDV_INFO_DESC_3' }],
                btns: [{ text: "FIND_OUT_MORE", class: 'btn-success', href: '/cards/kdv'}],
            },
        ];
        function getCards(cards) {
            return cards.map((card, index) => {
                return (
                  <CardListItem key={index} data={card}/>
                )
            })
        }
        getCards.bind(this);

    return (
        <div className="page-content cards-list">
            {isMobile ? <Breadcrumbs links={links} {...this.props} /> : ''}

            <div className="content">
                <div className="active-cards-list">
                    {getCards(activeCardsData)}
                </div>
                <div className="other-cards-list">
                    <div className="block-title">{this.l10n('BREADCRUMBS_OTHER_CARDS')}</div>
                    {getCards(otherCardsData)}
                </div>
            </div>

            <CustomDropdown title={this.l10n('CARDS_ARCHIVE')}>
                <div className="archive-cards-list">
                    {getCards(archiveCardsData)}
                </div>
            </CustomDropdown>

            <div className="download-app-wrapper">
                <DownloadApp {...this.props} />
            </div>

            {modal}
        </div>
    );
}
